// Single source of truth for the three payment lanes and their methods. The
// admin settings panel, the public checkout, and the Stripe method mapping all
// read from here. Config is stored additively on tournaments/{id}/info.payments:
//   payments: {
//     stripe:  { enabled, methods: { card, applePay, googlePay, cashApp } },
//     paypal:  { enabled, methods: { paypal, venmo, card } },
//     offline: { enabled, methods: { cash, check, proShop, memberAccount } },
//   }
// PBCC sets none of this → every lane reads disabled → behaviour unchanged.
export const LANES = [
  {
    key: 'stripe',
    label: 'Stripe',
    methods: [
      { key: 'card', label: 'Card' },
      { key: 'applePay', label: 'Apple Pay' },
      { key: 'googlePay', label: 'Google Pay' },
      { key: 'cashApp', label: 'Cash App Pay' },
    ],
  },
  {
    key: 'paypal',
    label: 'PayPal',
    methods: [
      { key: 'paypal', label: 'PayPal' },
      { key: 'venmo', label: 'Venmo' },
      { key: 'card', label: 'Card' },
    ],
  },
  {
    key: 'offline',
    label: 'Offline',
    methods: [
      { key: 'cash', label: 'Cash' },
      { key: 'check', label: 'Check' },
      { key: 'proShop', label: 'Pay at Pro Shop' },
      { key: 'memberAccount', label: 'Charge to Member Account' },
    ],
  },
]

export function laneEnabled(info, lane) {
  return !!info?.payments?.[lane]?.enabled
}

export function methodEnabled(info, lane, method) {
  const l = info?.payments?.[lane]
  return !!(l?.enabled && l?.methods?.[method])
}

// Enabled { key, label } methods for one lane (respecting the lane toggle).
export function enabledMethods(info, laneKey) {
  const lane = LANES.find((l) => l.key === laneKey)
  if (!lane || !laneEnabled(info, laneKey)) return []
  return lane.methods.filter((m) => methodEnabled(info, laneKey, m.key))
}

// Stripe Checkout payment_method_types from the toggles. Apple Pay / Google Pay
// are wallet surfaces that ride on the `card` type (Stripe shows them per device
// + registered domain), so any of card/applePay/googlePay contributes 'card';
// Cash App Pay is its own type.
export function stripePaymentMethodTypes(info) {
  const m = info?.payments?.stripe?.methods || {}
  const types = []
  if (m.card || m.applePay || m.googlePay) types.push('card')
  if (m.cashApp) types.push('cashapp')
  return types
}

// Does any lane expose an ONLINE (processor) method the public page can start?
export function hasOnlineCheckout(info) {
  return (laneEnabled(info, 'stripe') && stripePaymentMethodTypes(info).length > 0) ||
    enabledMethods(info, 'paypal').length > 0
}
